function initFaq(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	const faqs = root.querySelectorAll(".ea-faq");

	if (!faqs.length) return;

	Array.from(faqs).forEach((faq) => {
		const items = faq.querySelectorAll(".ea-faq__item");

		const getItemTrigger = (item) => {
			return item.querySelector(".ea-faq__item__trigger");
		};

		const getItemPanel = (item) => {
			return item.querySelector(".ea-faq__item__panel");
		};

		// toggle handler
		const toggle = (item) => {
			const trigger = getItemTrigger(item);
			const panel = getItemPanel(item);
			const expanded = trigger.getAttribute("aria-expanded") === "true";

			if (expanded) {
				trigger.setAttribute("aria-expanded", "false");
				panel.setAttribute("aria-hidden", "true");
				panel.classList.remove("is-open");
			} else {
				// Close currently open item
				items.forEach((otherItem) => {
					const otherTrigger = getItemTrigger(otherItem);
					if (otherTrigger.getAttribute("aria-expanded") === "true") {
						otherTrigger.setAttribute("aria-expanded", "false");
						getItemPanel(otherItem).setAttribute("aria-hidden", "true");
						getItemPanel(otherItem).classList.remove("is-open");
					}
				});

				trigger.setAttribute("aria-expanded", "true");
				panel.setAttribute("aria-hidden", "false");
				panel.classList.add("is-open");
			}
		};

		items.forEach((item) => {
			const trigger = getItemTrigger(item);
			trigger.addEventListener("click", () => toggle(item));
		});
	});
};

// Front-end
document.addEventListener("DOMContentLoaded", () => initFaq());

// Gutenberg / ACF editor
if (window.acf) {
	const initFaqScoped = ($block) => {
		initFaq($block && $block.jquery ? $block.get(0) : $block);
	};

	window.acf.addAction("render_block_preview/type=bloc-faq", initFaqScoped);

	window.acf.addAction("render_block_preview/type=bloc-accordion", initFaqScoped);
}
